// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"80e8f309","317":"0483d4ad","589":"7a160558"}[chunkId] + ".chunk.css";
};